export default "__VITE_ASSET__BWyiq_Vd__"